var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image',{staticClass:"logo",attrs:{"fit":_vm.fits,"alt":_vm.alt,"src":_vm.url}},[_c('div',{staticClass:"image-error",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture-outline"})])])}
var staticRenderFns = []

export { render, staticRenderFns }